import "bootstrap/dist/css/bootstrap.min.css";

import { ListGroup } from "react-bootstrap";

function School() {
  return (
    <>
      <div>
        <img style={{ width: "100%" }} alt="포스터" src="/school/21st.jpg" />
        {/* <img
          alt="낮고 긴 이미지"
          style={{ width: "100%" }}
          src="./topbanner2.jpg"
        /> */}
      </div>
      <ListGroup as="ol" numbered>
        <ListGroup.Item
          as="li"
          className="d-flex justify-content-between align-items-start">
          <div className="ms-2 me-auto">
            <div className="fw-bold">파워클라이밍스쿨이란?</div>약 1달여간 자연
            암벽과 센터에서 여러가지 등반 스킬과 이론을 배울 수 있음
          </div>
        </ListGroup.Item>

        <ListGroup.Item
          as="li"
          className="d-flex justify-content-between align-items-start">
          <div className="ms-2 me-auto">
            <div className="fw-bold">교육 내용</div>
            클라이밍 기본기, 테크닉, 트레이닝, 장비 사용법, 등반 시스템(확보법,
            멀티피치 시스템 등)
          </div>
        </ListGroup.Item>
        <ListGroup.Item
          as="li"
          className="d-flex justify-content-between align-items-start">
          <div className="ms-2 me-auto">
            <div className="fw-bold">교육 기간</div>
            <p>-3월~4월, 매주 주말(토,일)</p>
            <p>-토요일 : 이론수업 (16:00~19:00)</p>
            <p>-일요일 : 현장수업 (09:00~17:00)</p>
          </div>
        </ListGroup.Item>
        <ListGroup.Item
          as="li"
          className="d-flex justify-content-between align-items-start">
          <div className="ms-2 me-auto">
            <div className="fw-bold">기타</div>
            <p>
              - 교육비 : 100,000원(보험 가입, 교재 지급, 센터 교육 시 센터
              이용료)
            </p>
            <p>- 장비 : 교육기간동안 센터 장비 무상 대여</p>
          </div>
        </ListGroup.Item>
        <ListGroup.Item
          as="li"
          className="d-flex justify-content-between align-items-start">
          <div className="ms-2 me-auto">
            <div className="fw-bold">참가 신청</div>
            센터장 문의 010-3892-8850
          </div>
        </ListGroup.Item>
        <ListGroup.Item
          as="li"
          className="d-flex justify-content-between align-items-start">
          <div className="ms-2 me-auto">
            <div className="fw-bold">21기 모집중</div>
            <p>- 모집 기간 : ~ 23.03.22(수)</p>
            <p>- 오리엔테이션 : 23.03.24(금) 20:00</p>
          </div>
        </ListGroup.Item>
      </ListGroup>
    </>
  );
}

export default School;
